import { makeStyles } from "tss-react/mui";

const useScannerFormStyles = makeStyles()((theme) => ({
  container: {
    padding: theme.spacing(1),
    backgroundColor: theme.palette.surface.bgNuanced,
    boxShadow: "5px 10px 18px rgba(0,0,0,0.25)",
    zIndex: 1,
  },
  fields: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
  },
  row: {
    display: "flex",
    flexDirection: "row",
    gap: "4px",
  },
  iconButton: {
    backgroundColor: theme.palette.surface.light,
    borderRadius: "0 4px 4px 0",
  },
  iconButton0: {
    border: `1px solid ${theme.palette.strokes.defaultGrey}`,
    backgroundColor: theme.palette.surface.light,
    borderRadius: "0",
  },
  plusMinusButtons: {
    "& button:first-of-type": {
      borderRadius: "0",
      borderRight: `1px solid ${theme.palette.strokes.defaultGrey}`,
    },
  },
  hide: {
    display: "none",
  },
  hideContainer: {
    display: "flex",
    alignItems: "center",
    gap: "5px",
    justifyContent: "space-between",
  },
  hideDividers: {
    borderColor: theme.palette.strokes.defaultGrey,
    flexGrow: 1,
  },
  hideButton: {
    color: theme.palette.text.primary,
    padding: "0 8px 0 4px",
    display: "flex",
    alignItems: "center",
    gap: "4px",
    margin: "10px 0 2px 0",
    fontSize: "12px",
    maxWidth: "100px",
  },
}));

export default useScannerFormStyles;
